/* eslint-disable no-unused-vars */
import { EBusinessProposalStatus, EContractLossReason, EContractStatus, EDocumentSignStatus, EInvoiceCancelReason, EInvoiceStatus, ELossReason, EMaritalStatus, EProposalOrigin, EProposalStatus, EStage, ETermStatus } from '~/graphql/types'

const PROPOSAL_STATUS: { [x in EProposalStatus]: string } = {
  documentation: 'Documentação',
  formalization: 'Formalização',
  finalized: 'Contratado',
  canceled: 'Cancelado'
}

const MODULES_ACTIONS: { [x in string]: string } = {
  create: 'Criar',
  updated: 'Alterar',
  read: 'Ver',
  delete: 'Excluir'
}

const FIELDS_FORM: { [x in string]: string } = {
  zipcode: 'CEP',
  street: 'Rua',
  number: 'Número',
  state: 'Estado',
  city: 'Cidade',
  neighborhood: 'Bairro',
  complement: 'Complemento',

  personType: 'Tipo de pessoa',
  name: 'Nome',
  document: 'Documento',
  email: 'E-mail',
  phone: 'Telefone',
  maritalStatus: 'Estado civil',
  nationality: 'Nacionalidade',
  uf: 'Estado',
  dealership: 'Concessionária',
  dealershipId: 'Concessionária',
  dealershipName: 'Concessionária',
  averageEnergyBillValue: 'Valor médio de consumo',
  customerPfDocumentWithPhotoFront: 'Anexar RG ou CNH (Frente)',
  customerPjRepresentativeDocumentWithPhotoFront: 'Anexar RG ou CNH (Frente)',
  customerPfDocumentWithPhotoBack: 'Anexar RG ou CNH (Verso)',
  customerPjRepresentativeDocumentWithPhotoBack: 'Anexar RG ou CNH (Verso)',
  customerPjSocialContract: 'Contrato social',
  customerPjDocumentCard: 'Cartão CNPJ',
  energyBill: 'Ultima fatura de energia',
  identificationNumber: 'Número de identificação'
}

const MARITAL_STATUS: { [x in EMaritalStatus]: string } = {
  divorced: 'Divorciado(a)',
  married: 'Casado(a)',
  single: 'Solteiro(a)',
  widowed: 'Viúvo(a)'
}

const USER_MODULES: { [x in string]: string } = {
  users: 'Usuários',
  accessControl: 'Perfis',
  dealership: 'Concessionária',
  documentsign: 'Documentos',
  files: 'Arquivos',
  notification: 'Notificações',
  customers: 'Clientes',
  sellers: 'Vendedores',
  proposals: 'Propostas',
  powerGenerator: 'Geradores',
  powerPlants: 'Usinas',
  consortiums: 'Consórcios',
  contractNotes: 'Notas de contrato',
  partner: 'Parceiro',
  contracts: 'Contratos'
}

export function translateProposalStatus(status: EProposalStatus) {
  return PROPOSAL_STATUS[status] ?? status
}

const BUSINESS_PROPOSAL_STATUS: { [x in EBusinessProposalStatus]: string } = {
  allocated: 'Reservado',
  approved: 'Aprovado',
  finalized: 'Contratado',
  inAnalysis: 'Em análise',
  rejected: 'Recusado',
  canceled: 'Cancelado'
}
export const translateBusinessProposalStatus = (status: EBusinessProposalStatus) => {
  return BUSINESS_PROPOSAL_STATUS[status] ?? status
}

export function translateMaritalStatus(status?: EMaritalStatus) {
  if (!status) return ''
  return MARITAL_STATUS[status] ?? status
}

export function translateFieldsInput(status: string) {
  return FIELDS_FORM[status] ?? status
}

const CONTRACT_STATUS: { [x in EContractStatus]: string } = {
  sent: 'Disponível para rateio',
  reserved: 'Reservado',
  signatures: 'Assinaturas',
  deactivated: 'Desativado',
  inDeactivation: 'Em desativação',
  cancellationRequested: 'Cancelamento solicitado',
  active: 'Ativo'
}
export const translateContractStatus = (status: EContractStatus) => {
  return CONTRACT_STATUS[status] ?? status
}

const CUSTOMER_STATUS: { [x in string]: string } = {
  pending: 'Inativo',
  completed: 'Ativo'
}
export const translateCustomerStatus = (status: string) => {
  return CUSTOMER_STATUS[status] ?? status
}

export function modulesActionsTranslate(status: string) {
  return MODULES_ACTIONS[status] ?? status
}

export function userModulesTranslate(status: string) {
  return USER_MODULES[status] ?? status
}

const TERM_STATUS: { [x in ETermStatus]: string } = {
  signed: 'Assinado',
  canceled: 'Cancelado',
  replaced: 'Substituído',
  created: 'Aguardando assinatura',
  refused: 'Recusado',
  uploaded: 'Em análise',
  requestedSignature: 'Aguardando assinatura',
  expired: 'Expirado'
}
const DOCUMENT_SIGN_STATUS: { [x in EDocumentSignStatus]: string } = {
  created: 'Criado',
  expired: 'Expirado',
  pending: 'Pendente',
  refused: 'Recusado',
  signatureRequested: 'Aguardando assinatura',
  signed: 'Assinado',
  uploaded: 'Em análise',
  error: 'Erro'
}
export const translateTermStatus = (status: ETermStatus) => {
  return TERM_STATUS[status] ?? status
}

export const translateDocumentSignStatus = (status: EDocumentSignStatus) => {
  return DOCUMENT_SIGN_STATUS[status] ?? status
}

export enum EDigitalAccountStatus {
  'pending' = 'pending',
  'approved' = 'approved',
  'canceled' = 'canceled',
  'blocked' = 'blocked',
  'inactive' = 'inactive',
  'inAnalysis' = 'inAnalysis',
  'disapproved' = 'disapproved'
}

export enum EMonths {
  'january' = 'january',
  'february' = 'february',
  'march' = 'march',
  'april' = 'april',
  'may' = 'may',
  'june' = 'june',
  'july' = 'july',
  'august' = 'august',
  'september' = 'september',
  'october' = 'october',
  'november' = 'november',
  'december' = 'december'
}

const DIGITAL_ACCOUNT_STATUS = {
  pending: 'Pendente',
  approved: 'Aprovado',
  canceled: 'Cancelado',
  blocked: 'Bloqueado',
  inactive: 'Inativo',
  inAnalysis: 'Em análise',
  disapproved: 'Reprovado'
}

export const translateDigitalAccountStatus = (status: EDigitalAccountStatus) => {
  return DIGITAL_ACCOUNT_STATUS[status] ?? status
}

export const PROPOSAL_ORIGIN: { [x in EProposalOrigin]: string } = {
  internal: 'Desperta Energia',
  partner: 'Proposta manual',
  partnerApi: 'Integração API',
  partnerLink: 'Link de indicação',
  website: 'Website Desperta',
  rdStation: 'RD Station',
  bitrix: 'Bitrix',
  activeCampaign: 'Active Campaign',
  customer: 'Ação cliente indica cliente',
}

export const PROPOSAL_ORIGIN_TO_TABLE: { [x in EProposalOrigin]: string } = {
  internal: 'Backoffice',
  partner: 'Parceiro',
  partnerApi: 'Parceiro',
  partnerLink: 'Parceiro',
  website: 'Autoatendimento',
  rdStation: 'RD Station',
  bitrix: 'Bitrix',
  activeCampaign: 'Active Campaign',
  customer: 'Cliente'
}

export const translateProposalContractOrigin = (status: EProposalOrigin, origin: { [x in EProposalOrigin]: string }) => {
  return origin[status] ?? status
}

export const CONTRAC_INVOICE: { [x in EInvoiceStatus]: string } = {
  canceled: 'Cancelado',
  late: 'Atrasado',
  paid: 'Pago',
  pending: 'Pendente',
  requested: 'Requisitado',
  expired: 'Expirado',
  paymentRequest: 'Pagamento requisitado',
  createPayment: 'Pagamento criado',
  generatePDF: 'Fatura gerada',
  externalNegotiation: 'Neg. externa',
}

export const translateContractInvoice = (status: EInvoiceStatus, invoice: { [x in EInvoiceStatus]: string }) => {
  return invoice[status] ?? status
}

const LOSS_REASON: { [x in ELossReason]: string } = {
  beneficiaryDueToLowIncome: 'Beneficiado por baixa renda',
  leadCreatedForTesting: 'Lead criado para testes',
  duplicateLead: 'Lead duplicado',
  insufficientInvoiceAmount: 'Valor da fatura insuficiente',
  noContactReturned: 'Não retorna o contato',
  noInterestLostInterest: 'Não tem/perdeu o interesse',
  other: 'Outros',
  areaNotCovered: 'Área não atendida',
  buildingOwnPlantOrAlreadyHasOne: 'Está construindo a própria usina / possui usina',
  closedWithCompetitor: 'Fechou com a concorrência',
  companyChangingPartners: 'Empresa em processo de mudança de sócios',
  companyDeactivated: 'Empresa desativada',
  delinquent: 'Inadimplente',
  didNotSendDocumentation: 'Não envia a documentação',
  didNotUnderstandTheSolution: 'Não entendeu a solução',
  disagreesWithContractTerms: 'Não concorda com as condições contratuais',
  doesNotIntendToLeaveUtility: 'Não pretende sair da concessionária',
  incorrectEmail: 'E-mail errado',
  isInFreeMarket: 'Está no mercado livre',
  invalidOrMissingPhone: 'Telefone ausente ou inválido',
  linkExpiredAfter30Days: 'Link expirado após 30 dias',
  publicAgency: 'Órgão público',
  rejectedByCredit: 'Recusado pelo crédito (nome sujo)',
  rejectedByGenerator: 'Recusado pelo gerador / dono da usina',
  wantedDifferentDiscountPercentage: 'Cliente queria outro % de desconto',
  registrationMismatchWithInvoice: 'Cadastro divergente da fatura',
  lostToPartner: 'Perda para o parceiro',
  suspectedFraud: 'Suspeita de fraude',
}
const CONTRACT_LOSS_REASON: { [x in EContractLossReason]: string } = {
  beneficiaryDueToLowIncome: 'Beneficiado por baixa renda',
  leadCreatedForTesting: 'Lead criado para testes',
  duplicateLead: 'Lead duplicado',
  other: 'Outros',
  areaNotCovered: 'Área não atendida',
  buildingOwnPlantOrAlreadyHasOne: 'Está construindo a própria usina / possui usina',
  closedWithCompetitor: 'Fechou com a concorrência',
  companyChangingPartners: 'Empresa em processo de mudança de sócios',
  companyDeactivated: 'Empresa desativada',
  delinquent: 'Inadimplente',
  didNotUnderstandTheSolution: 'Não entendeu a solução',
  rejectedByGenerator: 'Recusado pelo gerador / dono da usina',
  lostToPartner: 'Perda para o parceiro',
  suspectedFraud: 'Suspeita de fraude',
}

export const translateLossReason = (status: ELossReason) => {
  return LOSS_REASON[status] ?? status
}
export const translateContractLossReason = (status: EContractLossReason) => {
  return CONTRACT_LOSS_REASON[status] ?? status
}

const INVOICE_CANCELED_LOSS_REASON: { [x in EInvoiceCancelReason]: string } = {
  incorrectData : 'Dados incorretos',
  incorrectInvoice : 'Fatura indevida',
  clientNegotiation : 'Negociação com o cliente',
  clientRetention : 'Retenção de cliente',
  wrongAmount : 'Valor incorreto',
  systemError : 'Erro do sistema',
  other : 'Outro'
}

export const translatEInvoiceCancelReason = (status: EInvoiceCancelReason) => {
  return INVOICE_CANCELED_LOSS_REASON[status] ?? status
}

const STAGE_FUNNEL: { [x in EStage]: string } = {
  awaitingSignature: 'Aguardando assinatura',
  contactReestablished: 'Contato retomado',
  firstContactAttempt: '1ª tentativa de contato',
  lead: 'Lead',
  legalAssembly: 'Jurídico/assembleia',
  lost: 'Perdido',
  negotiating: 'Negociando',
  negotiationCoolingDown: 'Negociação esfriando',
  opportunity: 'Oportunidade',
  proposalContracted: 'Proposta contratada',
  secondContactAttempt: '2ª tentativa de contato',
  thirdContactAttempt: '3ª tentativa de contato',
}

export const translateStageFunnel = (status: EStage) => {
  return STAGE_FUNNEL[status] ?? status
}

const MONTHS = {
  january: 'Janeiro',
  february: 'Fevereiro',
  march: 'Março',
  april: 'Abril',
  may: 'Maio',
  june: 'Junho',
  july: 'Julho',
  august: 'Agosto',
  september: 'Setembro',
  october: 'Outubro',
  november: 'Novembro',
  december: 'Dezembro'
}

export const translateMonth = (month: EMonths) => { 
  return MONTHS[month] ?? month
}